module.exports = __webpack_public_path__ + "img/us.7c1a2040.jpg";